export default __webpack_public_path__ + "static/media/alarmClock.e64703f5.jpeg";